import { Component, Input, output } from '@angular/core';

import type {
  ActivitySubscriptionType,
  ActivitySubscriptions,
  ActivitySubscriptionUpdateData,
} from '@recruitee/activities-types';
import { TranslatePipe } from '@recruitee/i18n';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-followed-requisitions',
  templateUrl: './activity-subscriptions-followed-requisitions.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  imports: [
    ActivitySubscriptionsTableComponent,
    TranslatePipe,
    ActivitySubscriptionsTableRowComponent,
  ],
})
export class ActivitySubscriptionsFollowedRequisitionsComponent {
  @Input() public types: ActivitySubscriptionType[];
  @Input() public activitySubscriptions: ActivitySubscriptions;
  public changeEvents = output<ActivitySubscriptionUpdateData>();
}
